import { memo } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

const CustomTabs = ({
    tabs = [],
    contents = [],
    value,
    setValue,
    indicatorBackgroundColor = "var(--id-color)",
    SelectedTextColor = "var(--id-color)",
    HoverTextColor = "var(--id-color)"
}) => {

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{
                        style: { backgroundColor: indicatorBackgroundColor, height: 3 },
                    }}
                    sx={{
                        ".MuiTab-root": {
                            fontSize: "14px",
                            fontWeight: 400,
                            textTransform: "none",
                            "&.Mui-selected": {
                                fontWeight: 600,
                                color: SelectedTextColor,
                            },
                            "&:hover": {
                                color: HoverTextColor,
                            },
                        },
                    }}
                >
                    {tabs.map((label, index) => (
                        <Tab key={index} label={label} />
                    ))}
                </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
                {contents.map((content, index) => (
                    <div key={index} hidden={value !== index}>
                        {value === index && content}
                    </div>
                ))}
            </Box>
        </Box>
    );
};

export default memo(CustomTabs);